/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StartEndDates {
  startDate: string;
  endDate: string;
}

export interface AvailableSpaces {
  count: number;
  firstEntryAvailable?: {
    startDate?: string;
    endDate?: string;
  };
  loading?: boolean;
  error?: boolean;
}

export interface DateSelectorState {
  startDate: string;
  endDate: string;
  availableSpaces: AvailableSpaces;
}

const initialState: DateSelectorState = {
  startDate: "",
  endDate: "",
  availableSpaces: {
    count: 0,
    firstEntryAvailable: {
      startDate: "",
      endDate: "",
    },
  },
};

const slice = createSlice({
  name: "dateSelectorState",
  initialState,
  reducers: {
    updateStartDate: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload;
    },
    updateEndDate: (state, action: PayloadAction<string>) => {
      state.endDate = action.payload;
    },
    updateAvailabilityCount: (
      state,
      action: PayloadAction<AvailableSpaces>,
    ) => {
      state.availableSpaces = action.payload;
    },
  },
});

export const dateSelectorStateActions = slice.actions;

export default slice.reducer;
